import React from 'react';

export const MacroTankestrek = () => {
    return <>{' – '}</>;
};
